import React from "react";
import webui, { BaseComponent } from "@tinqin/tinqin-web-ui";

const ZOOMING_ELEMENT_CLASS = "zoomArea";

//article zooming, expects a div with class="zoomArea"
class FontControl extends BaseComponent {
    constructor(props) {
        super(props);
        this.onIncreaseZoom = this.onIncreaseZoom.bind(this);
        this.onDecreseZoom = this.onDecreseZoom.bind(this);

        this.state = {
            zoomLevel: 0
        };
    }

    componentWillUnmount() {
        this.setZoomLevel(0);
    }

    onIncreaseZoom() {
        if (this.state.zoomLevel < 2) {
            const newZoomLevel = this.state.zoomLevel + 1;
            this.setState({
                zoomLevel: newZoomLevel
            });
            this.setZoomLevel(newZoomLevel);
        }
    }

    onDecreseZoom() {
        if (this.state.zoomLevel > -2) {
            const newZoomLevel = this.state.zoomLevel - 1;
            this.setState({
                zoomLevel: newZoomLevel
            });
            this.setZoomLevel(newZoomLevel);
        }
    }
    setZoomLevel(level = 0) {
        //scaling by 12.5%
        const zoomFactor = `${1 + level / 8}`;
        const scalingFactor = `scale(${zoomFactor})`;
        const zoomElement = document.getElementsByClassName(ZOOMING_ELEMENT_CLASS)[0];
        if (!zoomElement) {
            webui.error("Missing zoom element");
        } else {
            this.addScalingToElement(zoomElement, zoomFactor, scalingFactor, level);
        }
    }

    addScalingToElement(element, zoomFactor, scalingFactor, level) {
        element.style["transition"] = "none";
        element.style["height"] = "auto";
        element.style["ms-zoom"] = zoomFactor;
        element.style["-moz-transform"] = scalingFactor;
        element.style["-moz-transform-origin"] = "0 0";
        element.style["-o-transform"] = scalingFactor;
        element.style["-o-transform-origin"] = "0 0";
        element.style["-webkit-transform"] = scalingFactor;
        element.style["-webkit-transform-origin"] = "0 0";
        element.style["transform"] = scalingFactor;
        element.style["transform-origin"] = "0 0";

        //in order to keep the layout in place
        //height should be adjusted
        //width should be adjusted on Zoom in
        setTimeout(() => {
            if (level === 0) {
                element.style["width"] = "auto";
                element.style["height"] = "auto";
            } else {
                element.style["width"] = "540px";
                element.style["height"] = Math.round(element.getBoundingClientRect().height) + "px";
            }
        }, 100);
    }

    render() {
        const fontIncreasedClassname = this.state.zoomLevel > 0 ? "un-selected" : "";
        const fontDecreasedClassname = this.state.zoomLevel < 0 ? "un-selected" : "";
        return (
            <div
                className="tq-flex-container tq-flex-item-l-2 tq-flex-item-m-2
                      tq-flex-item-s-2 tq-flex-item-stretch tq-flex-container-grid tq-text-center un-bordered"
            >
                <div className="tq-flex-item">
                    <p
                        className={"tq-title tq-clickable un-zoom-in-btn " + fontIncreasedClassname}
                        onClick={this.onIncreaseZoom}
                    >
                        <span className="tq-text-node">A+</span>
                    </p>
                </div>
                <div className="tq-flex-item" onClick={this.onDecreseZoom}>
                    <p
                        className={
                            "tq-title tq-clickable un-zoom-out-btn " + fontDecreasedClassname
                        }
                    >
                        <span className="tq-text-node">A-</span>
                    </p>
                </div>
            </div>
        );
    }
}

export default webui.connectComponent({
    actions: {
        dispatchSirenActions: "siren.dispatchSirenActions"
    }
})(FontControl);
